import { ApolloError } from '@apollo/client'
// import { ImageJpgIcon, ImagePdfIcon, ImagePngIcon } from "assets/icons/absence";
import { getUrl } from 'aws-amplify/storage'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'

export const navigateToURL = url => {
    // Linking.openURL(url).catch((err) => console.error("An error occurred", err));
}

export const isInternetConnectionError = error => {
    if (!error) return false
    return error instanceof ApolloError && error.message === 'Network request failed'
}

export const isBase64 = str => {
    // Regular expression to check if the string is base64 encoded
    const base64Pattern = /^data:image\/[a-zA-Z]*;base64,/
    return base64Pattern.test(str)
}

// get s3 url from s3 key
export const getS3UrlFromKey = async s3Key => {
    try {
        const getUrlResult = await getUrl({
            path: s3Key,
        })
        return getUrlResult.url
    } catch (err) {
        return null
    }
}

// download file from s3
export const downloadFile = async (fileUrl, fileName) => {
    try {
        // Make sure a signed URL has been generated before attempting to download
        if (fileUrl) {
            // Fetch the file content directly
            const response = await fetch(fileUrl, { mode: 'no-cors' })
            const data = await response.arrayBuffer()

            // Create a Blob from the ArrayBuffer
            const blob = new Blob([data])

            // Create a link element and trigger a click to download the file
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'downloaded-file' // You can set the filename here
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } else {
        }
    } catch (error) {}
}

export const generateUniqueS3Key = (folderPath, fileName) => {
    const dateString = moment(new Date()).format('DDMMYYYY')
    // Generate a UUID with hyphens
    const generatedUUIDWithHyphens = uuidv4()

    // Remove hyphens from the UUID
    const generatedUUID = generatedUUIDWithHyphens.replace(/-/g, '')
    const key = `${dateString}-${generatedUUID}-${fileName}`
    const s3Key = `${folderPath}/${key}`
    return s3Key
}

export const truncateText = (text, lineCount, lineLength) => {
    const words = text.split(' ')
    let lines = ['']

    for (let word of words) {
        const currentLine = lines[lines.length - 1]

        if ((currentLine + word).length <= lineLength) {
            lines[lines.length - 1] += ` ${word}`
        } else {
            lines.push(word)
        }

        if (lines.length > lineCount) {
            lines = lines.slice(0, lineCount)
            lines[lines.length - 1] += '...'
            break
        }
    }

    return lines.join('\n')
}

export const getCountryName = countryData => {
    return countryData.country
}

export const getLookupTitleForMultiple = lookupData => {
    if (!lookupData) return ''
    const lang = 'en'
    const descriptions = []
    for (const lookup of lookupData) {
        descriptions.push(lookup.description[lang])
    }
    return descriptions.join(', ')
}

export const getLookupTitleForSingle = lookupData => {
    if (!lookupData) return ''
    const lang = 'en'
    return lookupData?.description[lang]
}

export const toCamelCase = word => {
    return word.charAt(0).toUpperCase() + word.slice(1)
}

export const formatDateOnly = dateString => {
    if (!dateString) {
        return ''
    }
    return moment(dateString).format('ll')
}

export const datePrettyFormat = dateString => {
    if (!dateString) {
        return ''
    }
    return moment(dateString).fromNow()
}

export const customDateFormat = dateString => {
    if (!dateString) {
        return ''
    }
    return moment(dateString).format('DD MMM YYYY')
}

export function customTimeFormat(timeString) {
    let date
    if (timeString?.includes(':')) {
        const [hours, minutes] = timeString.split(':')
        date = new Date()
        date.setUTCHours(hours, minutes, 0, 0)
    } else {
        date = new Date(timeString)
    }
    if (isNaN(date.getTime())) {
        date = new Date(Date.parse(timeString))
    }
    return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC', // Adjust this if you need a specific time zone
    })
}

export function utcDateTimeToBahrainTime(utcDateTime) {
    // Input timestamp in UTC
    const utcTime = new Date(utcDateTime)

    // Convert to Bahrain time and format to time string
    return utcTime.toLocaleTimeString('en-US', {
        timeZone: 'Asia/Bahrain',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    })
}

export const customDateTimeFormat = dateTimeString => {
    if (!dateTimeString) {
        return ''
    }
    return moment(dateTimeString).format('DD MMM YYYY hh:mm A')
}

export const getTimeDifference = (startTime, endTime) => {
    const start = moment(startTime, 'HH:mm')
    let end = moment(endTime, 'HH:mm')

    // If end time is before start time, add a day to end time
    if (end.isBefore(start)) {
        end.add(1, 'day')
    }
    const duration = moment.duration(end.diff(start))
    const hours = Math.floor(duration.asHours())
    const minutes = duration.minutes()
    return `${hours} h ${minutes} m`
}

//ADL CHD INF SNR
export const getAgeGroupByDateOfBirth = dateOfBirth => {
    const age = moment().diff(dateOfBirth, 'years')
    if (age >= 60) {
        return 'SNR'
    } else if (age >= 10) {
        return 'ADL'
    } else if (age >= 4) {
        return 'CHD'
    } else if (age >= 0) {
        return 'INF'
    }
    return ''
}

export const generateWeekDatesStartFromYesterday = () => {
    const tabs = []
    for (let i = -1; i < 7; i++) {
        const curDate = moment().add(i, 'days')
        tabs.push({
            label: curDate.format('YYYY-MM-DD'),
            value: curDate.format('YYYY-MM-DD'),
            day: i === -1 ? 'Yesterday' : i === 0 ? 'Today' : '',
            current: i === 0,
        })
    }
    return tabs
    // { name: '11/11/2024', href: '#', day: 'Yesterdsay', current: false },
}

export const generate30DayCalendar = () => {
    const tabs = []
    for (let i = -1; i < 30; i++) {
        const curDate = moment().add(i, 'days')
        tabs.push({
            label: curDate.format('YYYY-MM-DD'),
            value: curDate.format('YYYY-MM-DD'),
            day: i === -1 ? 'Yesterday' : i === 0 ? 'Today' : curDate.format('ddd'),
            current: i === 0,
        })
    }
    return tabs
}
